import React from "react";
import { CalendarDays, ExternalLink, ShieldCheck } from "lucide-react";

export default function Availability({ onBook }) {
  return (
    <section id="availability" data-testid="availability-section" className="relative py-20 sm:py-24 px-4 sm:px-6 lg:px-10">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block bg-brand-green text-slate-900 font-fredoka font-bold rounded-full px-4 py-1.5 border-4 border-slate-900 neo-shadow-sm rotate-[-2deg]">
            CHECK THE CALENDAR
          </span>
          <h2 className="font-fredoka font-bold text-4xl sm:text-5xl lg:text-6xl mt-6 text-slate-900">
            See your <span className="text-brand-red">dates.</span>
          </h2>
        </div>

        <div className="relative bg-white border-4 border-slate-900 rounded-3xl p-8 sm:p-12 neo-shadow-lg text-center">
          <div className="mx-auto w-16 h-16 grid place-items-center rounded-2xl bg-brand-yellow border-4 border-slate-900 neo-shadow-sm rotate-[-4deg]">
            <CalendarDays size={30} strokeWidth={2.5} />
          </div>
          <p className="mt-6 max-w-xl mx-auto text-lg text-slate-700 font-quicksand">
            Live availability and pricing for the <span className="font-bold text-slate-900">entire home</span> are handled by our
            property manager, <span className="font-bold text-slate-900">Home Team VR</span>. Tap below to view the calendar and
            complete your reservation securely on their booking page.
          </p>

          <button
            data-testid="availability-book-btn"
            onClick={onBook}
            className="mt-8 font-fredoka font-bold text-xl bg-brand-red text-white border-4 border-slate-900 rounded-full px-8 py-4 neo-shadow neo-press inline-flex items-center gap-2"
          >
            View Calendar &amp; Book
            <ExternalLink size={20} strokeWidth={2.5} />
          </button>

          <p className="mt-5 flex items-center justify-center gap-2 font-quicksand text-sm text-slate-500">
            <ShieldCheck size={16} /> Secure booking · Opens Home Team VR&rsquo;s reservation page
          </p>
        </div>
      </div>
    </section>
  );
}
